import { bootstrapPowerClerk } from "_Main/setupAnonEntrypoint";
import forgotPassword from "./forgotPassword.vue";
bootstrapPowerClerk(forgotPassword);
